/*
 * @Author: XuXin 2172438065@qq.com
 * @Date: 2024-06-21 08:35:01
 * @LastEditors: XuXin 2172438065@qq.com
 * @LastEditTime: 2025-05-20 16:26:42
 * @FilePath: \high-tech-materialsd:\workCode\xx\youbi\front\CustPC\src\utils\http.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * Created by rubin on 2020/6/4.
 */

"use strict";

import axios from "axios";
import { clearToken, getToken } from "./cookie";
import { MessageBox, Message } from "element-ui";
import panUtil from "./common";
import store from "../store";

const toLogin = function() {
    // to re-login
    MessageBox.confirm("您需要重新登陆", "确认退出登录", {
      confirmButtonText: "重新登陆",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      clearToken();
      store.commit("file/clear");
      store.commit("breadcrumb/clear");
      store.commit("navbar/clear");
      store.commit("user/clear");
      window.location.reload();
    });
  },
  http = axios.create({
    baseURL: panUtil.getUrlPrefix(),
    timeout: 1000 * 60,
    headers: {
      "Content-Type": "application/json;charset=utf-8",
    },
  });

http.interceptors.request.use(
  (config) => {
    config.data = {
      Data: {
        hqNo: store.getters.userInfo.hqNo,
        ...config.data,
      },
    };
    if (config.data) {
      config.data = JSON.stringify(config.data);
    }
    let token = getToken();
    if (token) {
      config.headers["Accesstoken"] = token;
    }
    return config;
  },
  (error) => {
    Message.error("请求失败");
    return;
  }
);

http.interceptors.response.use(
   (res) => {
    // 换token

    if (res.data.code === 401) {
      toLogin();
      // res.data.message = '您需要重新登陆'
      Message.error("您需要重新登陆");
      return Promise.reject("您需要重新登陆");
    }
    if (res.data.code !== 0) {
      Message.error(res.data.msg);

      return Promise.reject(res.data.msg);
    }
    return res.data;
  },
  (error) => {
    const { response } = error;
    if (response === undefined) {
      Message.error(
        "连接后台接口失败，可能由以下原因造成：后端不支持跨域CORS、接口地址不存在、请求超时等，请联系管理员排查后端接口问题"
      );
      return Promise.reject(
        "连接后台接口失败，可能由以下原因造成：后端不支持跨域CORS、接口地址不存在、请求超时等，请联系管理员排查后端接口问题"
      );
    } else {
      return Promise.reject(response.msg);
    }
  }
);

export default http;
